import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../../Stores/AuthStore";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuthStore();
  const location = useLocation();

  if (location.hash.startsWith("#login_with_access_token=")) {
    const access_token = location.hash.substring("#login_with_access_token=".length);
    return <Navigate to="/login" state={{ from: location, access_token }} replace />
  }

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
